// extracted by mini-css-extract-plugin
export var aircallIframe = "_lx-3";
export var fabContainer = "_lx-5";
export var fabRinging = "_lx-6";
export var loadingOverlay = "_lx-4";
export var pulse = "_lx-7";
export var widgetContent = "_lx-2";
export var widgetPanel = "_lx-0";
export var widgetPanelExpanded = "_lx-1";